import { render, staticRenderFns } from "./newCollec.vue?vue&type=template&id=9a1ce41c&scoped=true"
import script from "./newCollec.vue?vue&type=script&lang=js"
export * from "./newCollec.vue?vue&type=script&lang=js"
import style0 from "./newCollec.vue?vue&type=style&index=0&id=9a1ce41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1ce41c",
  null
  
)

export default component.exports